export interface IEtrackerProduct {
    id: string;
    name: string;
    price: string;
    currency?: string;
    category?: string[];
}

export interface IEtrackerOrder {
    orderNumber: string;
    status: string;
    orderPrice: string;
    currency?: string;
    customerGroup?: string;
    deliveryConditions?: string;
    paymentConditions?: string;
    basket?: object;
}

export const EtrackerEventNames = {
    INSERT_TO_WATCH_LIST: 'insertToWatchlist',
    REMOVE_FROM_WATCH_LIST: 'removeFromWatchlist',
    INSERT_TO_BASKET: 'insertToBasket',
    REMOVE_FROM_BASKET: 'removeFromBasket',
    VIEW_PRODUCT: 'viewProduct',
    VIEW_PRODUCT_LIST: 'viewProductList',
    ORDER: 'order',
    ODOSCOPE: "odoscope" // this one is custom defined, the rest are predefined by etracker
} as const;
